module.exports = __webpack_public_path__ + "img/yuzuobin.a7c3b860.jpg";